/** How a name of an uploaded class list relates to the students of the tenant. */
export enum EStudentNameMatch {
  /** A student of the class has the name, so the list adds nobody. */
  IN_CLASS = 'inClass',
  /** Exactly one other student of the tenant has the name. */
  EXISTING = 'existing',
  /** Several students of the tenant have the name, so the teacher picks who is meant. */
  AMBIGUOUS = 'ambiguous',
  /** No student of the tenant has the name. */
  NEW = 'new',
}
